import { Action } from "redux";
import { ActionCreator } from "typedActions";

/* set TenantId */
export const SET_TENANT_ID = "SET_TENANT_ID";
export interface SetTenantId extends Action { 
    tenantId: string; 
}
export const SetTenantIdAction = ActionCreator<SetTenantId>(SET_TENANT_ID);